{
  "$id": "wealthlane://forms/share-pool/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [
    {
      "id": "computeSharesAvailable",
      "watch": ["numberOfSharesAuthorised", "numberOfSharesUnAvailable"],
      "condition": {
        "meta": "mode",
        "in": ["create", "edit"]
      },
      "revalidateTargets": ["numberOfSharesUnAvailable"],
      "set": {
        "numberOfSharesAvailable": {
          "operator": "pipe",
          "steps": [
            {
              "operator": "subtract",
              "operands": [
                "numberOfSharesAuthorised",
                "numberOfSharesUnAvailable"
              ]
            },
            {
              "operator": "ifElse",
              "condition": { "lt": 0 },
              "then": { "operator": "value", "value": "" },
              "else": { "operator": "round", "decimals": 0 }
            }
          ]
        }
      }
    },
    {
      "id": "clearExternalPoolWhenUnchecked",
      "watch": "hasExternalPoolRefrence",
      "condition": {
        "field": "hasExternalPoolRefrence",
        "notEquals": true
      },
      "clear": ["externalPoolReferenceId"]
    }
  ],
  "rules": [
    {
      "id": "authorised-max-int",
      "target": "numberOfSharesAuthorised",
      "rule": "lessThan",
      "comparedTo": 2147483647,
      "message": "Must be less than 2147483647",
      "condition": {
        "field": "numberOfSharesAuthorised",
        "notEmpty": true
      }
    },
    {
      "id": "unavailable-not-greater-than-authorised",
      "target": "numberOfSharesUnAvailable",
      "rule": "lessThanOrEqual",
      "comparedTo": "numberOfSharesAuthorised",
      "message": "Must not be greater than No. of Shares Authorized",
      "condition": {
        "allOf": [
          { "field": "numberOfSharesUnAvailable", "notEmpty": true },
          { "field": "numberOfSharesAuthorised", "notEmpty": true }
        ]
      }
    }
  ],
  "observers": [
    {
      "id": "loadActiveTransferAgent",
      "runOnMount": true,
      "lookup": {
        "actionId": "FETCH_ACTIVE_TRANSFER_AGENT",
        "params": {}
      },
      "mapTo": {
        "isTransferAgentActive": "#/properties/isTransferAgentActive"
      }
    }
  ]
}
